"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtil = void 0;
var StringUtil = (function () {
    function StringUtil() {
    }
    StringUtil.isNum = function (str) {
        return !(this.isBlank(str) || isNaN(str));
    };
    StringUtil.isBlank = function (str) {
        return !str || !str.trim();
    };
    StringUtil.replaceAll = function (str, search, replacement) {
        return str.replace(new RegExp(search, 'g'), replacement);
    };
    StringUtil.remove = function (str, char) {
        if (typeof char === 'string') {
            return this._remove(str, [char]);
        }
        return this._remove(str, char);
    };
    StringUtil._remove = function (str, char) {
        for (var i = 0; i < char.length; i++) {
            str = this.replaceAll(str, char[i], '');
        }
        return str;
    };
    StringUtil._num = function (str) {
        if (!StringUtil.isNum(str)) {
            throw new TypeError("StringUtil: Unable to parse '" + str + "' to number");
        }
        return Number(str);
    };
    StringUtil._json = function (str) {
        return JSON.parse(str);
    };
    return StringUtil;
}());
exports.StringUtil = StringUtil;
//# sourceMappingURL=StringUtil.js.map